import React from 'react'
import { FormattedMessage } from 'react-intl'
import { useModal } from '@gluedigital/modal'

import './ClientSupportModal/ClientSupportModal'
import './ClientSupport.sass'

const ClientSupport = () => {
  const modal = useModal()

  return (
    <button onClick={() => modal.show('client-support-modal')} id="client-support">
      <span className="icon icon-chat" />
      <span className="text"><FormattedMessage id="client-support" /></span>
    </button>
  )
}

export default ClientSupport
